import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useLocation, json } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { logout } from "../../resuableFunctions/resuableFunctions";
import ParamsContext from "../useContext/paramContext";
import SearchBar from "../searchbar/searchbar";
import Endpoints from "../../config/APIEndpoints.json";
import navigation from "../../config/Navigation.json";
import { getDataFromCookies, removeDataFromCookie } from "../Cookies/Cookies";
import {
  getAllBrandList,
  getAllCategoriesData,
} from "../../resuableFunctions/resuableFunctions";
import logo_p1 from "../../Assets/logo_p1.webp";
import logo_p2 from "../../Assets/logo_p2.webp";
import NavbarCategorySwiper from "./navbarCategorySwiper";
import LoginUpdatedModal from "../loginUpdatedModel/login";
import LoginNewUpdatedModal from "../loginUpdatedModel/loginNew";
import CookieComponent from "../Cookies/CookieComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import "./navbar.css";
const MemoizedNavbarCategorySwiper = React.memo(NavbarCategorySwiper);
const MemoizedSearchbar = React.memo(SearchBar);
const SELLER_URL = process.env.REACT_APP_SELLER_DOMAIN;

const TopNavbar = () => {
  let [showChildCategoryId, setShowChildCategoryId] = useState("");
  const contextObj = useContext(ParamsContext);
  const dropdownRef = useRef(null);
  const [showDropDown, setShowDropDown] = useState(false);
  const [showSearchBackground, setShowSearchBackground] = useState(false);

  const [triggerClearSearchBar, setTriggerClearSearchBar] = useState(false);
  let filterParamsUpdated = [
    {
      columnName: "brand_id",
      values: [],
    },
    {
      columnName: "category_id",
      values: [],
    },
    {
      columnName: "age_group",
      values: [],
    },
    {
      columnName: "condition",
      values: [],
    },
    {
      columnName: "price_range",
      values: [],
    },
    {
      columnName: "sort",
      values: [],
    },
  ];
  let [displayName, setDisplayName] = useState("");
  useEffect(() => {
    setDisplayName(contextObj.params.displayName);
  }, [contextObj.params.displayName]);
  const reSetContextObj = () => {
    // contextObj.setInput("categoryFilterApplied", true);
    setDisplayName("");
    contextObj.setInput("serviceUnavailable", false);
    contextObj.setInput("multiFilters", "");
    contextObj.setInput("navigation", "false");
    contextObj.setInput("navigationFrom", "");
    contextObj.setInput("cartLength", 0);
    contextObj.setInput("wishlistLength", 0);
    contextObj.setInput("reFetchWishList", false);
    contextObj.setInput("reFetchCart", false);
    contextObj.setInput("protectedRoutes", false);
    contextObj.setInput("isLoggedIn", false);
    contextObj.setInput("showLoginModel", false);
    contextObj.setInput("paymentStatus", "");
    contextObj.setInput("displayName", "");
    contextObj.setInput("lastName", "");
    contextObj.setInput("getListLength", true);
    contextObj.setInput("featureFlagsAvailable", false);
    contextObj.setInput("featureFlags", null);
    contextObj.setInput("imgData", null);
    contextObj.setInput("checkoutProducts", []);
    contextObj.setInput("showAddressModal", false);
    contextObj.setInput("productAddedToWishlistId", "");
    contextObj.setInput("productRemovedFromWishlistId", "");
    contextObj.setInput("policiesData", []);
    contextObj.setInput("userProfile", null);
    contextObj.setInput("reFetchRecentlyViewProducts", false);
    contextObj.setInput("recentlyViewProducts", null);
    contextObj.setInput("navigateToOrderList", false);
    contextObj.setInput("reDirectToPage", "");
    contextObj.setInput("reSetFilters", false);
    contextObj.setInput("categoryFilterApplied", false);
    contextObj.setInput("resetSelectedCategoryId", false);
    contextObj.setInput("reFetchCartDetails", false);
    contextObj.setInput("reFetchAddressList", false);
    contextObj.setInput("updateProfileFromCheckout", false);
    contextObj.setInput("actionAfterLogin", "");
    contextObj.setInput("productId", "");
    contextObj.setInput("refetchAfterLoginAddWishList", false);
    contextObj.setInput("triggerReSetContextObj", false);
  };

  useEffect(() => {
    reSetContextObj();
  }, [contextObj.params.triggerReSetContextObj]);

  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  useEffect(() => {
    if (contextObj.params.resetSelectedCategoryId) {
      setSelectedCategoryId("");
    }
  }, [contextObj.params.resetSelectedCategoryId]);
  useEffect(() => {
    const session_filterParamsUpdated = sessionStorage.getItem(
      "filterParamsUpdated"
    );
    if (session_filterParamsUpdated !== null) {
      filterParamsUpdated = JSON.parse(session_filterParamsUpdated);
    }

    for (let i = 0; i < filterParamsUpdated.length; i++) {
      if (
        filterParamsUpdated[i].columnName == "category_id" &&
        filterParamsUpdated[i].values.length > 0
      ) {
        setSelectedCategoryId(filterParamsUpdated[i].values[0]);
      }
    }
  }, []);
  useEffect(() => {
    const removeKeyOnBeforeUnload = () => {
      sessionStorage.removeItem("parentCategoryListData");
      sessionStorage.removeItem("categoryListData");
    };
    window.addEventListener("beforeunload", removeKeyOnBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", removeKeyOnBeforeUnload);
    };
  }, []);

  const navigateToCategory = async (category) => {
    setSelectedCategoryId(category.id);

    const session_filterParamsUpdated = sessionStorage.getItem(
      "filterParamsUpdated"
    );
    if (session_filterParamsUpdated !== null) {
      filterParamsUpdated = await JSON.parse(session_filterParamsUpdated);
    }
    for (let i = 0; i < filterParamsUpdated.length; i++) {
      if (filterParamsUpdated[i].columnName == "category_id") {
        filterParamsUpdated[i].values == [];
        filterParamsUpdated[i].values = [category.id];
        break;
      }
    }
    sessionStorage.setItem(
      "filterParamsUpdated",
      JSON.stringify(filterParamsUpdated)
    );
    await contextObj.setInput("categoryFilterApplied", true);
    handleCloseClick();
    navigate(navigation.navigateToProductList);
  };

  const [categoriesData, setCategoriesData] = useState([]);
  const [maintainanceMode, setMaintainanceMode] = useState(false);
  const currentLocation = useLocation();

  const reFetchCategoriesData = async () => {
    let serviceUnavailable = await getAllCategoriesData();
    if (serviceUnavailable) {
      contextObj.setInput("serviceUnavailable", true);
    }
    let categoryInCookies = sessionStorage.getItem("parentCategoryListData"); // categoryListData

    categoryInCookies = JSON.parse(categoryInCookies);
    if (categoryInCookies && categoryInCookies.data) {
      categoryInCookies = categoryInCookies.data;
      setCategoriesData(categoryInCookies);
    }
  };

  useEffect(() => {
    if (window.innerWidth <= 600) {
      if (window.innerWidth <= 600) {
        let categoryInCookies = sessionStorage.getItem(
          "parentCategoryListData"
        ); // categoryListData
        if (!categoryInCookies) {
          reFetchCategoriesData();
        } else {
          categoryInCookies = JSON.parse(categoryInCookies);
          if (categoryInCookies && categoryInCookies.data) {
            categoryInCookies = categoryInCookies.data;
            setCategoriesData(categoryInCookies);
          }
        }
      }
    }
  }, []);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 600) {
        let categoryInCookies = sessionStorage.getItem(
          "parentCategoryListData"
        ); // categoryListData
        if (!categoryInCookies) {
          reFetchCategoriesData();
        } else {
          categoryInCookies = JSON.parse(categoryInCookies);
          if (categoryInCookies && categoryInCookies.data) {
            categoryInCookies = categoryInCookies.data;
            setCategoriesData(categoryInCookies);
          }
        }
      }
    };

    // Initial call to set overflow based on the initial screen size
    handleResize();

    // Add a resize event listener to update overflow when the screen size changes
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
      document.body.style.overflow = "auto"; // Enable scroll when the modal is closed
    };
  }, []);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      let isFirstLoad = sessionStorage.getItem("isFirstLoad");
      let pathName = location.pathname;
      if (
        isFirstLoad !== false &&
        !getDataFromCookies("7H3K9R5P2Q") &&
        (pathName == "/" ||
          pathName == `${navigation.navigateToProductList}` ||
          pathName.startsWith(`${navigation.navigateToProductList}/`))
      ) {
        sessionStorage.setItem("isFirstLoad", false);
        if (contextObj.params.showLoginModel !== true) {
          contextObj.setInput("showLoginModel", true);
        }
      }
    }, 7000);
    return () => clearTimeout(timeoutId);
  }, []);

  let API_HOST = process.env.REACT_APP_API_HOST;
  const [isOpen, setIsOpen] = useState(false);
  const [showFeatures, setShowFeatures] = useState({
    showWishList: true,
    sellWithUs: true,
    searchbar: true,
    myOrders: true,
    recentlyViewedProducts: true,
    similarProducts: true,
    buyer_common_hamburger: true,
    buyer_common_topribbon: true,
    showCategoryFilter: true,
    buyer_mobile_login_signup_modal_view: true,
    flagsUpdated: false,
  });
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const sidebarRef = useRef(null);
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.userSelect = "none";
    } else {
      document.body.style.overflow = "auto";
      document.body.style.userSelect = "auto";
    }
  }, [isMobileMenuOpen]);
  useEffect(() => {
    let featureFlags = contextObj.params.featureFlags;
    if (featureFlags) {
      setShowFeatures((prev) => ({
        ...prev,
        showWishList: featureFlags.buyer_products_wishlist,
        sellWithUs: featureFlags.buyer_sellerconsolelink,
        myOrders: featureFlags.buyer_profile_myorders,
        recentlyViewedProducts: featureFlags.buyer_common_recentlyvisiteditems,
        similarProducts: featureFlags.buyer_productdetails_similarproducts,
        buyer_common_hamburger: featureFlags.buyer_common_hamburger,
        buyer_common_topribbon: featureFlags.buyer_common_topribbon,
        showCategoryFilter: featureFlags.buyer_products_categories,
        buyer_mobile_login_signup_modal_view:
          featureFlags.buyer_mobile_login_signup_modal_view,
        flagsUpdated: true,
      }));
    }
  }, [contextObj.params.featureFlags]);
  useEffect(() => {
    if (contextObj.params.featureFlags == null) {
      let featureFlags = getDataFromCookies("featureFlags");
      if (featureFlags) {
        contextObj.setInput("featureFlags", featureFlags);
      }
    }
  }, []);
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.classList.contains("navbar__hamburger")
      ) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleHamburgerClick = () => {
    setShowChildCategoryId("");
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleCloseClick = () => {
    setShowChildCategoryId("");
    setMobileMenuOpen(false);
    setIsOpen(false);
  };

  // if user is logged in fetch cart data

  const fetchProfileData = async () => {
    let token = getDataFromCookies("7H3K9R5P2Q");
    if (token == null) {
      return;
    }
    const response = await fetch(`${API_HOST}/${Endpoints.buyerProfile}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const res = await response.json();
    if (
      res.status == 500 ||
      res.status == 501 ||
      res.status == 502 ||
      res.status == 503 ||
      (res.message && res.message.toLowerCase().includes("server error"))
    ) {
      contextObj.setInput("serviceUnavailable", true);
    } else {
      contextObj.setInput("serviceUnavailable", false);
    }
    if (res.status === 200) {
      const firstLetterFirstName = res.data.f_name.split(" ")[0];

      const initials = firstLetterFirstName;

      contextObj.setInput("userProfile", res.data);
      contextObj.setInput("displayName", initials);
      setDisplayName(initials);

      return true;
    } else {
      contextObj.setInput("displayName", "");

      return false;
    }
  };
  const getFeatureFlags = async () => {
    const url = `${API_HOST}/${Endpoints.getBuyerFeatureFlags}`;

    await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        if (
          res.status >= 500 ||
          (res.message && res.message.toLowerCase().includes("server error"))
        ) {
          if (res.status == 503) {
            setMaintainanceMode(true);
          } else {
            setMaintainanceMode(false);
          }
          contextObj.setInput("serviceUnavailable", true);
        } else {
          contextObj.setInput("serviceUnavailable", false);
        }
        if (res.data) {
          let featureFlags = {};
          res.data.forEach((data) => {
            featureFlags[data.name] = data.value;
          });

          contextObj.setInput("featureFlags", featureFlags);
        }
      })
      .catch((err) => {
        console.error(err);
        if (err.message.includes("Failed to fetch")) {
          contextObj.setInput("serviceUnavailable", true);
        }
      });
  };
  useEffect(() => {
    if (contextObj.params.featureFlags == null) {
      getFeatureFlags();
    }
  }, [contextObj.params.featureFlags]);

  // get cart count
  const fetchCartData = async () => {
    const isLoggedIn = getDataFromCookies("isLoggedIn");
    if (isLoggedIn == true) {
      const token = getDataFromCookies("7H3K9R5P2Q");
      const response = await fetch(
        `${API_HOST}/${Endpoints.buyerCartDetails}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      const res = await response.json();

      if (res.status === 200) {
        contextObj.setInput("cartLength", res.data.total);
      } else if (res.status === 404) {
        contextObj.setInput("cartLength", res.data.total);
      } else if (res.status == 401) {
        removeDataFromCookie("7H3K9R5P2Q", "/");
        removeDataFromCookie("isLoggedIn", "/");
        contextObj.setInput("navigation", "true");
        contextObj.setInput("navigationFrom", "sessionExpired");
        contextObj.setInput("isLoggedIn", false);
      } else if (
        res.status == 500 ||
        res.status == 501 ||
        res.status == 502 ||
        res.status == 503 ||
        (res.message && res.message.toLowerCase().includes("server error"))
      ) {
        contextObj.setInput("serviceUnavailable", true);
      } else {
        contextObj.setInput("serviceUnavailable", false);
      }
    }
  };

  useEffect(() => {
    let isLoggedIn = getDataFromCookies("isLoggedIn");
    let token = getDataFromCookies("7H3K9R5P2Q");
    if (isLoggedIn == true && token !== "" && token !== null) {
      contextObj.setInput("isLoggedIn", true);
      fetchCartData();
    }
  }, [contextObj.params.reFetchCartDetails]);

  const closeDropdown = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [dropdownRef]);

  useEffect(() => {
    if (
      contextObj.params.isLoggedIn == true &&
      contextObj.params.userProfile == null
    ) {
      fetchProfileData();
    }
  }, [contextObj.params.isLoggedIn, contextObj.params.isLoggedIn.userProfile]);
  const navigate = useNavigate();

  const Name = `${contextObj.params.displayName} ${contextObj.params.lastName}`;
  const [CharacterToShow, setCharacterToShow] = useState(0);

  useEffect(() => {
    setCharacterToShow(window.innerWidth > 600 ? 18 : 20);

    let brandsInCookies = sessionStorage.getItem("brandsListData");

    if (brandsInCookies === null || brandsInCookies === undefined) {
      getAllBrandList();
    } else {
      brandsInCookies = JSON.parse(brandsInCookies);
      brandsInCookies = brandsInCookies.data;
    }
  }, []);
  const [showPrivacyCookies, setShowPrivacyCookies] = useState(false);
  const updateValueShowPrivacyCookies = (newValue) => {
    setShowPrivacyCookies(newValue);
  };
  useEffect(() => {
    let guestUserAcceptedCookie = getDataFromCookies("guestUserAcceptedCookie");
    let loggedIn = getDataFromCookies("isLoggedIn");
    if (guestUserAcceptedCookie == null && loggedIn !== true) {
      setShowPrivacyCookies(true);
    } else {
      setShowPrivacyCookies(false);
    }
  }, []);

  return (
    <div className="navbar-body" id="navbarBodyContainer">
      {contextObj.params.showLoginModel == true &&
        showFeatures.flagsUpdated == true && (
          <>
            {showFeatures.buyer_mobile_login_signup_modal_view ? (
              <LoginNewUpdatedModal
                updateValueShowPrivacyCookies={updateValueShowPrivacyCookies}
              />
            ) : (
              <LoginUpdatedModal
                updateValueShowPrivacyCookies={updateValueShowPrivacyCookies}
              />
            )}
          </>
        )}
      <nav className="main-navbar">
        <div className="main-navbar-container">
          <>
            {showFeatures.buyer_common_hamburger && (
              <button
                className={`navbar__hamburger ${
                  isMobileMenuOpen ? "open" : ""
                }`}
                name="navbarHamburger"
                style={{ marginBottom: "2px" }}
                onClick={handleHamburgerClick}
              >
                <FaBars />
              </button>
            )}
          </>

          {/* app logo */}
          <button
            className="navbar__logo navbar-logocontainer-button"
            onClick={() => {
              // console.log("currentLocation =====>");
              if (currentLocation.pathname == "/") {
                window.location.reload();
              } else {
                navigate(`${navigation.navigateToHomepage}`);
              }
            }}
          >
            <div className="navbarLogoContainer">
              <img
                src={logo_p1}
                alt="logo"
                style={{
                  width: "34px",
                  height: "25px",
                }}
              />
              <img
                src={logo_p2}
                alt="logo"
                style={{
                  width: "70px",
                  height: "25px",
                }}
              />
            </div>
          </button>

          {/* search bar */}
          <div className="searchbarContainer">
            <MemoizedSearchbar
              showSearchBackground={setShowSearchBackground}
              clearSeachBox={triggerClearSearchBar}
            />
          </div>

          {showSearchBackground && (
            <div
              className="searchbarBackgroundDiv"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setTriggerClearSearchBar(!triggerClearSearchBar);
                setShowSearchBackground(false);
              }}
            ></div>
          )}

          {/* navbar right side isons */}
          <div className="navbar__icons">
            <>
              {showFeatures.sellWithUs && (
                <button
                  className="navbarIcon sell_with-us-button"
                  onClick={(e) => {
                    window.open(SELLER_URL, "_blank");
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  id="becomeASeller"
                >
                  {/* Webview */}
                  <svg
                    // width="50"
                    // height="50"
                    viewBox="0 0 45 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="WebViewOnly navbarIconCircleContainer"
                  >
                    <circle
                      className="navbarIcon-circle"
                      cx="22.5"
                      cy="22.5"
                      r="22.5"
                      fill="#D9D9D9"
                      fillOpacity="0.2"
                    />
                    <mask id="path-2-inside-1_0_1" fill="white">
                      <path d="M14.9 16.1667V15.5333C14.5981 15.5333 14.3382 15.7464 14.279 16.0425L14.9 16.1667ZM30.1 16.1667L30.721 16.0425C30.6617 15.7464 30.4018 15.5333 30.1 15.5333V16.1667ZM31.3666 22.5V23.1333C31.5564 23.1333 31.7361 23.0483 31.8565 22.9015C31.9767 22.7548 32.0249 22.5619 31.9877 22.3758L31.3666 22.5ZM13.6333 22.5L13.0123 22.3758C12.9751 22.5619 13.0233 22.7548 13.1436 22.9015C13.2638 23.0483 13.4436 23.1333 13.6333 23.1333V22.5ZM17.4333 26.3H16.8V26.9333H17.4333V26.3ZM27.5667 26.3V26.9333H28.2V26.3H27.5667ZM13 32H32V30.7333H13V32ZM14.2667 22.5V31.3667H15.5333V22.5H14.2667ZM29.4666 22.5V31.3667H30.7333V22.5H29.4666ZM14.9 16.8H30.1V15.5333H14.9V16.8ZM29.4789 16.2909L30.7456 22.6242L31.9877 22.3758L30.721 16.0425L29.4789 16.2909ZM31.3666 21.8667H13.6333V23.1333H31.3666V21.8667ZM14.2544 22.6242L15.521 16.2909L14.279 16.0425L13.0123 22.3758L14.2544 22.6242ZM14.2667 14.2667H30.7333V13H14.2667V14.2667ZM16.8 22.5V26.3H18.0667V22.5H16.8ZM17.4333 26.9333H27.5667V25.6667H17.4333V26.9333ZM28.2 26.3V22.5H26.9333V26.3H28.2Z" />
                    </mask>
                    <path
                      d="M14.9 16.1667L14.5078 18.1278L16.9 18.6063V16.1667H14.9ZM30.1 16.1667H28.1V18.6063L30.4922 18.1278L30.1 16.1667ZM30.721 16.0425L32.6822 15.6502L32.6821 15.6498L30.721 16.0425ZM31.3666 22.5L30.9744 20.5388L29.3666 20.8604V22.5H31.3666ZM31.8565 22.9015L33.403 24.1697L33.4036 24.169L31.8565 22.9015ZM13.6333 22.5H15.6333V20.8604L14.0256 20.5388L13.6333 22.5ZM13.0123 22.3758L11.0511 21.9836L11.0511 21.9836L13.0123 22.3758ZM13.1436 22.9015L14.6903 21.6336L14.6902 21.6335L13.1436 22.9015ZM17.4333 26.3H19.4333V24.3H17.4333V26.3ZM16.8 26.9333H14.8V28.9333H16.8V26.9333ZM27.5667 26.3V24.3H25.5667V26.3H27.5667ZM28.2 26.9333V28.9333H30.2V26.9333H28.2ZM13 32H11V34H13V32ZM32 32V34H34V32H32ZM32 30.7333H34V28.7333H32V30.7333ZM13 30.7333V28.7333H11V30.7333H13ZM14.2667 22.5V20.5H12.2667V22.5H14.2667ZM14.2667 31.3667H12.2667V33.3667H14.2667V31.3667ZM15.5333 31.3667V33.3667H17.5333V31.3667H15.5333ZM15.5333 22.5H17.5333V20.5H15.5333V22.5ZM29.4666 22.5V20.5H27.4666V22.5H29.4666ZM29.4666 31.3667H27.4666V33.3667H29.4666V31.3667ZM30.7333 31.3667V33.3667H32.7333V31.3667H30.7333ZM30.7333 22.5H32.7333V20.5H30.7333V22.5ZM14.9 16.8H12.9V18.8H14.9V16.8ZM30.1 16.8V18.8H32.1V16.8H30.1ZM29.4789 16.2909L29.0867 14.3297L27.1255 14.7219L27.5178 16.6831L29.4789 16.2909ZM30.7456 22.6242L28.7844 23.0164L29.1767 24.9776L31.1378 24.5854L30.7456 22.6242ZM31.3666 21.8667H33.3666V19.8667H31.3666V21.8667ZM13.6333 21.8667V19.8667H11.6333V21.8667H13.6333ZM14.2544 22.6242L13.8621 24.5854L15.8233 24.9776L16.2155 23.0164L14.2544 22.6242ZM15.521 16.2909L17.4822 16.6831L17.8744 14.722L15.9133 14.3297L15.521 16.2909ZM14.2667 14.2667H12.2667V16.2667H14.2667V14.2667ZM30.7333 14.2667V16.2667H32.7333V14.2667H30.7333ZM30.7333 13H32.7333V11H30.7333V13ZM14.2667 13V11H12.2667V13H14.2667ZM16.8 22.5V20.5H14.8V22.5H16.8ZM18.0667 26.3V28.3H20.0667V26.3H18.0667ZM18.0667 22.5H20.0667V20.5H18.0667V22.5ZM27.5667 25.6667H29.5667V23.6667H27.5667V25.6667ZM17.4333 25.6667V23.6667H15.4333V25.6667H17.4333ZM28.2 22.5H30.2V20.5H28.2V22.5ZM26.9333 22.5V20.5H24.9333V22.5H26.9333ZM26.9333 26.3H24.9333V28.3H26.9333V26.3ZM16.9 16.1667V15.5333H12.9V16.1667H16.9ZM14.9 13.5333C13.6448 13.5333 12.564 14.4193 12.3178 15.6502L16.2401 16.4347C16.1124 17.0735 15.5515 17.5333 14.9 17.5333V13.5333ZM13.8867 18.0036L14.5078 18.1278L15.2922 14.2055L14.6712 14.0813L13.8867 18.0036ZM30.4922 18.1278L31.1133 18.0036L30.3288 14.0813L29.7077 14.2055L30.4922 18.1278ZM32.6821 15.6498C32.4357 14.4195 31.3554 13.5333 30.1 13.5333V17.5333C29.4482 17.5333 28.8878 17.0734 28.76 16.4352L32.6821 15.6498ZM28.1 15.5333V16.1667H32.1V15.5333H28.1ZM29.3666 22.5V23.1333H33.3666V22.5H29.3666ZM31.3666 25.1333C32.1556 25.1333 32.9029 24.7796 33.403 24.1697L30.3099 21.6333C30.5694 21.317 30.9571 21.1333 31.3666 21.1333V25.1333ZM33.4036 24.169C33.9028 23.5596 34.1038 22.7577 33.9488 21.9833L30.0266 22.7683C29.9461 22.366 30.0505 21.95 30.3093 21.6341L33.4036 24.169ZM31.5955 20.4146L30.9744 20.5388L31.7589 24.4612L32.3799 24.337L31.5955 20.4146ZM14.0256 20.5388L13.4045 20.4146L12.6201 24.337L13.2411 24.4612L14.0256 20.5388ZM11.0511 21.9836C10.8964 22.7572 11.0967 23.5594 11.5969 24.1695L14.6902 21.6335C14.9498 21.9502 15.0538 22.3665 14.9735 22.768L11.0511 21.9836ZM11.5968 24.1695C12.097 24.7796 12.8444 25.1333 13.6333 25.1333V21.1333C14.0428 21.1333 14.4307 21.3169 14.6903 21.6336L11.5968 24.1695ZM15.6333 23.1333V22.5H11.6333V23.1333H15.6333ZM17.4333 24.3H16.8V28.3H17.4333V24.3ZM14.8 26.3V26.9333H18.8V26.3H14.8ZM16.8 28.9333H17.4333V24.9333H16.8V28.9333ZM19.4333 26.9333V26.3H15.4333V26.9333H19.4333ZM25.5667 26.3V26.9333H29.5667V26.3H25.5667ZM27.5667 28.9333H28.2V24.9333H27.5667V28.9333ZM30.2 26.9333V26.3H26.2V26.9333H30.2ZM28.2 24.3H27.5667V28.3H28.2V24.3ZM13 34H32V30H13V34ZM34 32V30.7333H30V32H34ZM32 28.7333H13V32.7333H32V28.7333ZM11 30.7333V32H15V30.7333H11ZM12.2667 22.5V31.3667H16.2667V22.5H12.2667ZM14.2667 33.3667H15.5333V29.3667H14.2667V33.3667ZM17.5333 31.3667V22.5H13.5333V31.3667H17.5333ZM15.5333 20.5H14.2667V24.5H15.5333V20.5ZM27.4666 22.5V31.3667H31.4666V22.5H27.4666ZM29.4666 33.3667H30.7333V29.3667H29.4666V33.3667ZM32.7333 31.3667V22.5H28.7333V31.3667H32.7333ZM30.7333 20.5H29.4666V24.5H30.7333V20.5ZM14.9 18.8H30.1V14.8H14.9V18.8ZM32.1 16.8V15.5333H28.1V16.8H32.1ZM30.1 13.5333H14.9V17.5333H30.1V13.5333ZM12.9 15.5333V16.8H16.9V15.5333H12.9ZM27.5178 16.6831L28.7844 23.0164L32.7068 22.232L31.4401 15.8986L27.5178 16.6831ZM31.1378 24.5854L32.3799 24.337L31.5955 20.4146L30.3534 20.663L31.1378 24.5854ZM33.9489 21.9836L32.6822 15.6502L28.7599 16.4347L30.0265 22.768L33.9489 21.9836ZM30.3288 14.0813L29.0867 14.3297L29.8712 18.252L31.1133 18.0036L30.3288 14.0813ZM31.3666 19.8667H13.6333V23.8667H31.3666V19.8667ZM11.6333 21.8667V23.1333H15.6333V21.8667H11.6333ZM13.6333 25.1333H31.3666V21.1333H13.6333V25.1333ZM33.3666 23.1333V21.8667H29.3666V23.1333H33.3666ZM16.2155 23.0164L17.4822 16.6831L13.5599 15.8986L12.2932 22.232L16.2155 23.0164ZM15.9133 14.3297L14.6712 14.0813L13.8867 18.0036L15.1288 18.252L15.9133 14.3297ZM12.3178 15.6502L11.0511 21.9836L14.9735 22.768L16.2401 16.4347L12.3178 15.6502ZM12.6201 24.337L13.8621 24.5854L14.6466 20.6631L13.4045 20.4146L12.6201 24.337ZM14.2667 16.2667H30.7333V12.2667H14.2667V16.2667ZM32.7333 14.2667V13H28.7333V14.2667H32.7333ZM30.7333 11H14.2667V15H30.7333V11ZM12.2667 13V14.2667H16.2667V13H12.2667ZM14.8 22.5V26.3H18.8V22.5H14.8ZM16.8 28.3H18.0667V24.3H16.8V28.3ZM20.0667 26.3V22.5H16.0667V26.3H20.0667ZM18.0667 20.5H16.8V24.5H18.0667V20.5ZM17.4333 28.9333H27.5667V24.9333H17.4333V28.9333ZM29.5667 26.9333V25.6667H25.5667V26.9333H29.5667ZM27.5667 23.6667H17.4333V27.6667H27.5667V23.6667ZM15.4333 25.6667V26.9333H19.4333V25.6667H15.4333ZM30.2 26.3V22.5H26.2V26.3H30.2ZM28.2 20.5H26.9333V24.5H28.2V20.5ZM24.9333 22.5V26.3H28.9333V22.5H24.9333ZM26.9333 28.3H28.2V24.3H26.9333V28.3Z"
                      fill="white"
                      mask="url(#path-2-inside-1_0_1)"
                    />
                  </svg>
                  <p className="navbarIcon-text WebViewOnly display-none-under-1024 ">
                    Become a Seller
                  </p>

                  {/* mobileview */}
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="mobileViewOnly"
                  >
                    <path
                      d="M17.7323 1.26667H1.26562V0H17.7323V1.26667Z"
                      fill="white"
                    />
                    <path
                      d="M1.27896 3.04233C1.33818 2.74629 1.5981 2.5332 1.9 2.5332H17.1C17.4018 2.5332 17.6619 2.74629 17.721 3.04233L18.9877 9.37565C19.0249 9.56171 18.9767 9.75465 18.8565 9.90138C18.7361 10.0481 18.5564 10.1332 18.3666 10.1332H0.633338C0.443596 10.1332 0.26385 10.0481 0.143555 9.90138C0.0232609 9.75465 -0.0249072 9.56171 0.0123044 9.37565L1.27896 3.04233Z"
                      fill="white"
                    />
                    <path
                      d="M1.26667 11.4004V17.7337H0V19.0004H19V17.7337H17.7333V11.4004H15.2V13.9337H3.8V11.4004H1.26667Z"
                      fill="white"
                    />
                    <path
                      d="M5.06641 11.4004H13.9331V12.6671H5.06641V11.4004Z"
                      fill="white"
                    />
                  </svg>
                </button>
              )}

              {/* cart icon */}
              <button
                className="navbarIcon sell_with-us-button"
                id="navbarCartBtn"
                onClick={() => {
                  sessionStorage.removeItem("login_input");
                  if (getDataFromCookies("isLoggedIn") == true) {
                    let currentRoute = location.pathname;
                    if (currentRoute == navigation.navigateToNewCartPage) {
                      window.location.reload();
                    } else {
                      navigate(`${navigation.navigateToNewCartPage}`);
                    }
                  } else {
                    contextObj.setInput("reDirectToPage", "cart");
                    contextObj.setInput("showLoginModel", true);
                  }
                }}
              >
                {/* webview cart icon */}
                <svg
                  id="addTocartIconDiv"
                  viewBox="0 0 50 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="WebViewOnly navbarIconCircleContainer"
                >
                  <circle
                    className="navbarIcon-circle"
                    cx="22.5"
                    cy="22.5"
                    r="22.5"
                    fill="#D9D9D9"
                    fillOpacity="0.2"
                  />
                  <path
                    d="M15.079 14.9413L16.892 26.7203C16.9247 26.9551 17.0419 27.1698 17.2217 27.3242C17.4015 27.4787 17.6315 27.5621 17.8685 27.5589H28.5294C28.7382 27.5589 28.9414 27.4916 29.1089 27.3669C29.2764 27.2423 29.3993 27.0669 29.4592 26.8669L32.3709 17.161C32.4144 17.0161 32.4233 16.8631 32.397 16.7141C32.3708 16.5651 32.3101 16.4243 32.2197 16.3029C32.1294 16.1816 32.012 16.083 31.8768 16.0151C31.7416 15.9472 31.5924 15.9119 31.4411 15.9119H17.1929L16.8726 13.8368C16.8403 13.5992 16.7205 13.3822 16.5368 13.2282C16.3579 13.0772 16.1303 12.9962 15.8962 13.0001H13.9706C13.8431 13.0001 13.7169 13.0252 13.5992 13.074C13.4814 13.1228 13.3744 13.1943 13.2843 13.2844C13.1942 13.3745 13.1227 13.4815 13.0739 13.5993C13.0251 13.7171 13 13.8433 13 13.9707C13 14.0982 13.0251 14.2244 13.0739 14.3422C13.1227 14.4599 13.1942 14.5669 13.2843 14.657C13.3744 14.7472 13.4814 14.8187 13.5992 14.8674C13.7169 14.9162 13.8431 14.9413 13.9706 14.9413H15.079ZM18.6857 25.6177L17.4919 17.8531H30.1366L27.8072 25.6177H18.6857ZM20.7647 30.4707C20.7647 30.9855 20.5602 31.4792 20.1961 31.8433C19.8321 32.2073 19.3383 32.4118 18.8235 32.4118C18.3087 32.4118 17.8149 32.2073 17.4509 31.8433C17.0869 31.4792 16.8823 30.9855 16.8823 30.4707C16.8823 29.9558 17.0869 29.4621 17.4509 29.0981C17.8149 28.734 18.3087 28.5295 18.8235 28.5295C19.3383 28.5295 19.8321 28.734 20.1961 29.0981C20.5602 29.4621 20.7647 29.9558 20.7647 30.4707ZM29.4999 30.4707C29.4999 30.9855 29.2954 31.4792 28.9314 31.8433C28.5673 32.2073 28.0736 32.4118 27.5588 32.4118C27.0439 32.4118 26.5502 32.2073 26.1862 31.8433C25.8221 31.4792 25.6176 30.9855 25.6176 30.4707C25.6176 29.9558 25.8221 29.4621 26.1862 29.0981C26.5502 28.734 27.0439 28.5295 27.5588 28.5295C28.0736 28.5295 28.5673 28.734 28.9314 29.0981C29.2954 29.4621 29.4999 29.9558 29.4999 30.4707Z"
                    fill="white"
                  />
                </svg>
                <span className="WebViewOnly">
                  <span
                    className="navbar__icon-badge"
                    style={{
                      opacity:
                        getDataFromCookies("7H3K9R5P2Q") &&
                        contextObj.params.cartLength > 0
                          ? 1
                          : 0,
                    }}
                  >
                    {getDataFromCookies("isLoggedIn") &&
                      contextObj.params.cartLength}
                  </span>
                </span>
                <p className="navbarIcon-text WebViewOnly display-none-under-1024 cartIconText">
                  Cart
                </p>

                {/* mobile view cart icon */}
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mobileViewOnly"
                >
                  <path
                    d="M2.94831 4.16528L0 1.26559L1.28642 0L4.23382 2.90058H18.0908C18.2325 2.90057 18.3723 2.93315 18.4989 2.99572C18.6255 3.05828 18.7355 3.1491 18.8201 3.26093C18.9048 3.37276 18.9616 3.5025 18.9862 3.6398C19.0108 3.77709 19.0024 3.91814 18.9618 4.05169L16.7798 11.207C16.7237 11.3913 16.6086 11.5529 16.4517 11.6678C16.2948 11.7827 16.1045 11.8447 15.9089 11.8447H4.76658V13.6335H14.767V15.4224H3.85744C3.61633 15.4224 3.38509 15.3281 3.21459 15.1604C3.0441 14.9926 2.94831 14.7652 2.94831 14.5279V4.16528ZM4.31201 19C3.95034 19 3.60347 18.8587 3.34773 18.607C3.09199 18.3554 2.94831 18.0142 2.94831 17.6584C2.94831 17.3026 3.09199 16.9613 3.34773 16.7097C3.60347 16.4581 3.95034 16.3168 4.31201 16.3168C4.67369 16.3168 5.02055 16.4581 5.27629 16.7097C5.53203 16.9613 5.67571 17.3026 5.67571 17.6584C5.67571 18.0142 5.53203 18.3554 5.27629 18.607C5.02055 18.8587 4.67369 19 4.31201 19ZM15.2216 19C14.8599 19 14.5131 18.8587 14.2573 18.607C14.0016 18.3554 13.8579 18.0142 13.8579 17.6584C13.8579 17.3026 14.0016 16.9613 14.2573 16.7097C14.5131 16.4581 14.8599 16.3168 15.2216 16.3168C15.5833 16.3168 15.9301 16.4581 16.1859 16.7097C16.4416 16.9613 16.5853 17.3026 16.5853 17.6584C16.5853 18.0142 16.4416 18.3554 16.1859 18.607C15.9301 18.8587 15.5833 19 15.2216 19Z"
                    fill="white"
                  />
                </svg>
                <span className="mobileViewOnly">
                  <span
                    className="navbar__icon-badge"
                    style={{
                      opacity:
                        getDataFromCookies("7H3K9R5P2Q") &&
                        contextObj.params.cartLength > 0
                          ? 1
                          : 0,
                    }}
                  >
                    {getDataFromCookies("isLoggedIn")
                      ? contextObj.params.cartLength
                      : 0}
                  </span>
                </span>
              </button>

              <div
                className="login-profile-dropdown"
                onMouseEnter={() => {
                  setShowDropDown(true);
                }}
                onMouseLeave={() => {
                  setShowDropDown(false);
                }}
                onClick={() => {
                  if (showDropDown) {
                    setShowDropDown(false);
                  }
                }}
              >
                {getDataFromCookies("isLoggedIn") == null ? (
                  <button
                    className="login-btn-area"
                    onClick={async () => {
                      await contextObj.setInput("showLoginModel", true);
                    }}
                  >
                    <button
                      type="button"
                      className="NavbarLoginBtn"
                      id="NavbarLoginBtnTxt"
                    >
                      Login
                    </button>
                  </button>
                ) : (
                  <button
                    className="navbarIcon loginBtnIcon nav-user-icon sell_with-us-button"
                    id="isLoggedInProfileDropdown"
                    onClick={() => {
                      if (getDataFromCookies("isLoggedIn") == true) {
                        if (window.innerWidth > 600) {
                          navigate(navigation.navigateToProfileInfo);
                        } else {
                          navigate(navigation.navigateToUserSideNavbar);
                        }
                      } else {
                        contextObj.setInput("showLoginModel", true);
                      }
                    }}
                  >
                    {/* webview user icon */}
                    <svg
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="WebViewOnly navbarIconCircleContainer"
                    >
                      <circle
                        className="navbarIcon-circle"
                        cx="22.5"
                        cy="22.5"
                        r="22.5"
                        fill="#D9D9D9"
                        fillOpacity="0.2"
                      />
                      <path
                        d="M25.3529 16.7059C25.3529 18.2003 24.1415 19.4118 22.6471 19.4118C21.1526 19.4118 19.9412 18.2003 19.9412 16.7059C19.9412 15.2115 21.1526 14 22.6471 14C24.1415 14 25.3529 15.2115 25.3529 16.7059ZM15.0648 30.5294C15.5547 26.7786 18.7626 23.8824 22.6471 23.8824C26.5315 23.8824 29.7394 26.7786 30.2293 30.5294H15.0648Z"
                        stroke="white"
                        stroke-width="2"
                      />
                    </svg>
                    <p
                      className="navbarIcon-text WebViewOnly display-none-under-1024"
                      style={{
                        opacity: displayName ? 1 : 0,
                      }}
                    >
                      {displayName
                        ? displayName.length > 14
                          ? `${displayName.substring(0, 14)}...`
                          : displayName
                        : "User"}
                    </p>

                    {/* mobile view user icon */}
                    <svg
                      width="23"
                      height="19"
                      viewBox="0 0 23 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mobileViewOnly"
                    >
                      <path
                        d="M8.05 9.5C10.5908 9.5 12.65 7.37363 12.65 4.75C12.65 2.12637 10.5908 0 8.05 0C5.50922 0 3.45 2.12637 3.45 4.75C3.45 7.37363 5.50922 9.5 8.05 9.5ZM11.27 10.6875H10.6698C9.87203 11.066 8.98437 11.2812 8.05 11.2812C7.11562 11.2812 6.23156 11.066 5.43015 10.6875H4.83C2.16344 10.6875 0 12.9215 0 15.675V17.2188C0 18.2021 0.772656 19 1.725 19H14.375C15.3273 19 16.1 18.2021 16.1 17.2188V15.675C16.1 12.9215 13.9366 10.6875 11.27 10.6875ZM22.8778 5.92266L21.8787 4.87988C21.7134 4.70547 21.4439 4.70547 21.275 4.87617L17.5087 8.73555L15.8736 7.03594C15.7083 6.86152 15.4387 6.86152 15.2698 7.03223L14.26 8.06758C14.0911 8.23828 14.0911 8.5166 14.2564 8.69102L17.1925 11.7451C17.3578 11.9195 17.6273 11.9195 17.7962 11.7488L22.8742 6.54609C23.0395 6.37168 23.0431 6.09336 22.8778 5.92266Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                )}
                {!contextObj.params.showLoginModel && showDropDown && (
                  <div
                    className="navbar__dropdown"
                    id="navbar__dropdown"
                    style={{
                      top: getDataFromCookies("isLoggedIn") ? "70px" : "60px",
                    }}
                  >
                    <ul>
                      <>
                        {getDataFromCookies("isLoggedIn") == null && (
                          <li
                            className="signup-li"
                            id="navbarDropDownListSignUp"
                            onClick={async () => {
                              await contextObj.setInput("showLoginModel", true);
                            }}
                          >
                            <p className="signup-text">
                              New Customer? <span>Sign up</span>
                            </p>
                          </li>
                        )}

                        {/* my profile */}
                        <li
                          className="navbarDropDownList"
                          id="navbarDropDownListMyProfile"
                          onClick={() => {
                            setIsOpen(false);
                            if (getDataFromCookies("isLoggedIn") == true) {
                              if (window.outerWidth > 600) {
                                let currentRoute = location.pathname;
                                if (
                                  currentRoute ==
                                  navigation.navigateToProfileInfo
                                ) {
                                  window.location.reload();
                                } else {
                                  navigate(
                                    `${navigation.navigateToProfileInfo}`
                                  );
                                }
                              } else {
                                navigate(navigation.navigateToUserSideNavbar);
                              }
                            } else {
                              contextObj.setInput(
                                "reDirectToPage",
                                "userProfile"
                              );
                              contextObj.setInput("showLoginModel", true);
                            }
                          }}
                        >
                          {/* user icon */}
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 11 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.35714 2.4C7.35714 3.45788 6.51725 4.3 5.5 4.3C4.48279 4.3 3.64286 3.45787 3.64286 2.4C3.64286 1.34213 4.48279 0.5 5.5 0.5C6.51725 0.5 7.35714 1.34213 7.35714 2.4ZM0.52368 11.5C0.770243 8.91117 2.91147 6.9 5.5 6.9C8.08853 6.9 10.2298 8.91117 10.4763 11.5H0.52368Z"
                              stroke="#979797"
                            />
                          </svg>
                          My Profile
                        </li>

                        {/* my orders */}
                        {showFeatures.myOrders && (
                          <li
                            id="navbarDropDownListMyOrder"
                            onClick={() => {
                              setIsOpen(false);
                              if (getDataFromCookies("isLoggedIn")) {
                                if (window.outerWidth > 600) {
                                  let currentRoute = location.pathname;
                                  if (
                                    currentRoute == navigation.navigateToOrder
                                  ) {
                                    window.location.reload();
                                  } else {
                                    navigate(`${navigation.navigateToOrder}`);
                                  }
                                } else {
                                  navigate(navigation.navigateToUserSideNavbar);
                                }
                              } else {
                                contextObj.setInput("reDirectToPage", "orders");
                                contextObj.setInput("showLoginModel", true);
                              }
                            }}
                          >
                            {/* my orer icon */}
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 11 11"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.35 0.6H1.65C1.07009 0.6 0.6 1.07011 0.6 1.65V9.35C0.6 9.92991 1.07011 10.4 1.65 10.4H9.35C9.92991 10.4 10.4 9.92991 10.4 9.35V1.65C10.4 1.0701 9.92991 0.6 9.35 0.6ZM0.5 1.65C0.5 1.01487 1.01487 0.5 1.65 0.5H9.35C9.98515 0.5 10.5 1.01487 10.5 1.65V9.35C10.5 9.98515 9.98515 10.5 9.35 10.5H1.65C1.01487 10.5 0.5 9.98515 0.5 9.35V1.65ZM5.5 5C4.46106 5 3.48001 4.06784 3.285 2.7H3.38568C3.58014 4.03402 4.53878 4.9 5.5 4.9C6.46122 4.9 7.41986 4.03402 7.61432 2.7H7.715C7.51999 4.06784 6.53893 5 5.5 5Z"
                                stroke="#979797"
                              />
                            </svg>
                            My Orders
                          </li>
                        )}

                        {/* wishlist */}
                        {showFeatures.showWishList && (
                          <li
                            id="navbarDropDownListMyWishList"
                            onClick={() => {
                              setIsOpen(false);
                              if (getDataFromCookies("isLoggedIn") == true) {
                                if (window.outerWidth > 600) {
                                  let currentRoute = location.pathname;
                                  if (
                                    currentRoute ==
                                    navigation.navigateToWishlist
                                  ) {
                                    window.location.reload();
                                  } else {
                                    navigate(
                                      `${navigation.navigateToWishlist}`
                                    );
                                  }
                                } else {
                                  navigate(navigation.navigateToUserSideNavbar);
                                }
                              } else {
                                contextObj.setInput(
                                  "reDirectToPage",
                                  "wishlist"
                                );
                                contextObj.setInput("showLoginModel", true);
                              }
                            }}
                          >
                            {/* wishlist icon */}
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 13 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.086 6.36081L6.50509 11L1.92413 6.36081M1.92413 6.36081C1.62197 6.06016 1.38397 5.69879 1.2251 5.29946C1.06624 4.90013 0.989957 4.4715 1.00106 4.04055C1.01216 3.60959 1.11041 3.18566 1.28961 2.79543C1.46881 2.40521 1.72509 2.05716 2.04231 1.77319C2.35953 1.48922 2.73081 1.27549 3.13278 1.14545C3.53474 1.01541 3.95869 0.97189 4.37792 1.01762C4.79714 1.06335 5.20257 1.19734 5.56867 1.41115C5.93476 1.62497 6.25359 1.91398 6.50509 2.25998C6.75767 1.91649 7.07688 1.63001 7.44272 1.41846C7.80856 1.20691 8.21317 1.07486 8.63122 1.03056C9.04927 0.986258 9.47177 1.03067 9.87226 1.16101C10.2728 1.29135 10.6426 1.50482 10.9587 1.78804C11.2748 2.07127 11.5304 2.41817 11.7093 2.80702C11.8883 3.19588 11.9868 3.61831 11.9988 4.0479C12.0107 4.47748 11.9358 4.90497 11.7788 5.30359C11.6217 5.70222 11.3859 6.06341 11.086 6.36455"
                                fill="white"
                              />
                              <path
                                d="M11.086 6.36081L6.50509 11L1.92413 6.36081C1.62197 6.06016 1.38397 5.69879 1.2251 5.29946C1.06624 4.90013 0.989957 4.4715 1.00106 4.04055C1.01216 3.60959 1.11041 3.18566 1.28961 2.79543C1.46881 2.40521 1.72509 2.05716 2.04231 1.77319C2.35953 1.48922 2.73081 1.27549 3.13278 1.14545C3.53474 1.01541 3.95869 0.97189 4.37792 1.01762C4.79714 1.06335 5.20257 1.19734 5.56867 1.41115C5.93476 1.62497 6.25359 1.91398 6.50509 2.25998C6.75767 1.91649 7.07688 1.63001 7.44272 1.41846C7.80856 1.20691 8.21317 1.07486 8.63122 1.03056C9.04927 0.986258 9.47177 1.03067 9.87226 1.16101C10.2728 1.29135 10.6426 1.50482 10.9587 1.78804C11.2748 2.07127 11.5304 2.41817 11.7093 2.80702C11.8883 3.19588 11.9868 3.61832 11.9988 4.0479C12.0107 4.47748 11.9358 4.90497 11.7788 5.30359C11.6217 5.70222 11.3859 6.06341 11.086 6.36455"
                                stroke="#979797"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            Wishlist
                          </li>
                        )}

                        {getDataFromCookies("isLoggedIn") && (
                          <>
                            <li
                              id="navbarDropDownListLogout"
                              className="logout-li"
                              onClick={async () => {
                                setIsOpen(false);

                                // await contextObj.setInput("userProfile", null);
                                // await contextObj.setInput("cartLength", 0);
                                // await contextObj.setInput("displayName", "");
                                // await contextObj.setInput("lastName", "");
                                // await contextObj.setInput("reSetFilters", true);
                                await logout();

                                await contextObj.setInput(
                                  "triggerReSetContextObj",
                                  true
                                );

                                // await contextObj.setInput("isLoggedIn", false);
                                // await contextObj.setInput("cartLength", 0);
                                setShowDropDown(false);
                                navigate(`${navigation.navigateToHomepage}`);
                                // document.getElementById("navbar__dropdown")
                                //   .style;
                              }}
                            >
                              {/* logout icon */}
                              <svg
                                width="15"
                                height="15"
                                viewBox="0 0 10 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M2.07895 10.45V9.3H2.13158V9.9V10.4H2.63158H8.94737H9.44737V9.9V1.1V0.6H8.94737H2.63158H2.13158V1.1V1.7H2.07895V0.55C2.07895 0.529812 2.08683 0.514639 2.09435 0.506781C2.09788 0.503087 2.10083 0.501434 2.10247 0.500724C2.10407 0.50003 2.10493 0.5 2.10526 0.5H9.47368C9.47402 0.5 9.47487 0.50003 9.47648 0.500725C9.47812 0.501435 9.48107 0.503087 9.4846 0.506781C9.49212 0.514638 9.5 0.52981 9.5 0.55V10.45C9.5 10.4702 9.49212 10.4854 9.4846 10.4932L9.84585 10.8389L9.4846 10.4932C9.48106 10.4969 9.47812 10.4986 9.47648 10.4993C9.47488 10.5 9.47402 10.5 9.47368 10.5H2.10526C2.10492 10.5 2.10407 10.5 2.10247 10.4993C2.10083 10.4986 2.09788 10.4969 2.09435 10.4932L1.7331 10.8389L2.09435 10.4932C2.08683 10.4854 2.07895 10.4702 2.07895 10.45ZM2.13158 6.63029L0.779555 5.5L2.13158 4.36971V4.95V5.45H2.63158H5.81579V5.55H2.63158H2.13158V6.05V6.63029Z"
                                  stroke="#979797"
                                />
                              </svg>
                              Logout
                            </li>
                          </>
                        )}
                      </>
                    </ul>
                  </div>
                )}
              </div>
            </>
          </div>
        </div>
      </nav>

      {/* Media queries apply for small screen to see sidebar menu */}
      <div className={`navbar__menu ${isMobileMenuOpen ? "open" : ""}`}>
        {isMobileMenuOpen && (
          <div
            ref={sidebarRef}
            className="sidebarContainer"
            onClick={(e) => {
              handleHamburgerClick();
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <div
              className="sidebar"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <div className="sidebarHeadingAndButtonDiv">
                <div>
                  <p className="helloText">Hello,</p>

                  {contextObj.params.isLoggedIn === false ? (
                    <p className="nameTextInMobile">Guest</p>
                  ) : (
                    <p className="nameTextInMobile">
                      {Name.length > CharacterToShow
                        ? `${Name.substring(0, CharacterToShow)}...`
                        : Name}
                    </p>
                  )}
                </div>
                <div className="closeButtonDivForHamburger">
                  <button
                    className="closeIconForHamburger"
                    onClick={handleCloseClick}
                  >
                    <svg
                      width="14"
                      height="15"
                      viewBox="0 0 11 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 10.6429L10 1"
                        stroke="#EBDCDC"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10 10.6429L1 1"
                        stroke="#EBDCDC"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              <div className="listofItemsDivInSidebar">
                <div>
                  <ul className="listOfToys">
                    <li
                      onClick={async () => {
                        await contextObj.setInput("reSetFilters", true);
                        setSelectedCategoryId("allProducts");
                        window.scrollTo(0, 0);
                        handleCloseClick();
                        let currentRoute = location.pathname;
                        console.log("currentRoute ==========>", currentRoute);
                        if (currentRoute == navigation.navigateToProductList) {
                          alert("reload");
                          window.location.reload();
                        } else {
                          setSelectedCategoryId("allProducts");

                          navigate(`${navigation.navigateToProductList}`);
                        }
                      }}
                    >
                      All Products
                    </li>
                    {showFeatures.showCategoryFilter &&
                      categoriesData &&
                      categoriesData.map((category) => {
                        return (
                          <li
                            onClick={() => {
                              if (
                                category.childCategory &&
                                category.childCategory.length == 0
                              ) {
                                navigateToCategory(category);
                              } else {
                                setShowChildCategoryId(
                                  showChildCategoryId == category.id
                                    ? ""
                                    : category.id
                                );
                              }
                            }}
                            id={
                              selectedCategoryId == category.id
                                ? "showActiveCategoryFilter"
                                : ""
                            }
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                // justifyContent: "space-between",
                              }}
                            >
                              {" "}
                              <div>
                                {" "}
                                <p
                                  style={{
                                    margin: "0px",

                                    color:
                                      showChildCategoryId == category.id &&
                                      "#ea5e3d",
                                  }}
                                >
                                  {category.name}
                                </p>
                              </div>
                              {category.childCategory &&
                                category.childCategory.length > 0 && (
                                  <div
                                    style={{
                                      marginLeft: "20px",
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={
                                        showChildCategoryId == category.id
                                          ? faAngleUp
                                          : faAngleDown
                                      }
                                      style={{
                                        color: "#c4c4c4",
                                      }}
                                    />
                                  </div>
                                )}
                            </div>
                            {category.childCategory &&
                              category.childCategory.length > 0 &&
                              showChildCategoryId == category.id && (
                                <div className="mobileViewChildCategories">
                                  {category.childCategory.map((item) => {
                                    return (
                                      <div
                                        onClick={() => {
                                          navigateToCategory(item);
                                        }}
                                      >
                                        {item.name}
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                          </li>
                        );
                      })}
                  </ul>
                  <hr className="lineBetweenTwoDivs" />
                </div>

                {contextObj.params.isLoggedIn === true ? (
                  <div>
                    <ul className="listOfOptionForAccess">
                      <li
                        onClick={() => {
                          handleCloseClick();
                          let currentRoute = location.pathname;
                          if (
                            currentRoute == navigation.navigateToProfileInfo
                          ) {
                            window.location.reload();
                          } else {
                            navigate(`${navigation.navigateToProfileInfo}`);
                          }
                        }}
                      >
                        Account
                      </li>
                      {showFeatures.myOrders && (
                        <li
                          onClick={() => {
                            handleCloseClick();
                            let currentRoute = location.pathname;
                            if (currentRoute == navigation.navigateToOrder) {
                              window.location.reload();
                            } else {
                              navigate(`${navigation.navigateToOrder}`);
                            }
                          }}
                        >
                          My Orders
                        </li>
                      )}
                      {showFeatures.showWishList && (
                        <li
                          onClick={() => {
                            handleCloseClick();
                            let currentRoute = location.pathname;
                            if (currentRoute == navigation.navigateToWishlist) {
                              window.location.reload();
                            } else {
                              navigate(`${navigation.navigateToWishlist}`);
                            }
                          }}
                        >
                          Wishlist
                        </li>
                      )}
                      <li
                        onClick={() => {
                          handleCloseClick();
                          let currentRoute = location.pathname;
                          if (
                            currentRoute == navigation.navigateToNewCartPage
                          ) {
                            window.location.reload();
                          } else {
                            navigate(`${navigation.navigateToNewCartPage}`);
                          }
                        }}
                      >
                        My Cart
                      </li>
                    </ul>
                    <hr className="lineBetweenTwoDivs" />
                  </div>
                ) : null}

                <div>
                  <ul className="listOfOptionForAccess">
                    <li
                      onClick={() => {
                        handleCloseClick();
                        navigate(navigation.navigateToFaq);
                      }}
                    >
                      FAQ'S
                    </li>
                    <li
                      onClick={() => {
                        handleCloseClick();
                        navigate(navigation.navigateToContact);
                      }}
                    >
                      Contact Us
                    </li>
                    {showFeatures.sellWithUs && (
                      <li
                        onClick={(e) => {
                          {
                            e.preventDefault();
                            e.stopPropagation();
                            handleCloseClick();
                            window.open(SELLER_URL, "_blank");
                          }
                        }}
                      >
                        Become a Seller
                      </li>
                    )}
                  </ul>
                  <hr className="lineBetweenTwoDivs" />
                </div>

                {contextObj.params.isLoggedIn && (
                  <ul className="listOfOptionForAccess">
                    <li
                      onClick={async () => {
                        setIsOpen(false);
                        try {
                          handleCloseClick();
                          // contextObj.setInput("userProfile", null);
                          await logout();
                          await contextObj.setInput(
                            "triggerReSetContextObj",
                            true
                          );
                          // await contextObj.setInput("navigation", "true");
                          // await contextObj.setInput("navigationFrom", "logout");
                          // await contextObj.setInput("cartLength", 0);
                          // await contextObj.setInput("isLoggedIn", false);
                          navigate(`${navigation.navigateToHomepage}`);
                        } catch (error) {
                          console.error("Logout failed:", error);
                          if (error.message.includes("Failed to fetch")) {
                            contextObj.setInput("serviceUnavailable", true);
                          }
                        }
                      }}
                    >
                      Logout
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {showFeatures.buyer_common_topribbon && (
        <div className="navbar-menu">
          <div className="navbar-menu-container">
            <MemoizedNavbarCategorySwiper />
          </div>
        </div>
      )}

      {showPrivacyCookies && contextObj.params.isLoggedIn != true && (
        <CookieComponent showPrivacyCookies={setShowPrivacyCookies} />
      )}
    </div>
  );
};

export default TopNavbar;
